export const BONE_LOSS_OPTIONS = [
  {
    label: "Greater than 50% bone loss (horizontal/vertical/combined)",
    name: "greaterThan50PerCentBoneLoss"
  },
  {
    label: "25-50% bone loss (horizontal/vertical/combined)",
    name: "between25And50PerCentBoneLoss"
  },
  {
    label: "Less than 25% bone loss (horizontal/vertical/combined)",
    name: "lessThan25PerCentBoneLoss"
  }
];

export const OTHER_OPTIONS = [
  { label: "Missing Teeth", name: "missingTeeth" },
  { label: "Retained Tooth Roots", name: "retainedToothRoots" },
  { label: "Unerupted Teeth", name: "uneruptedTeeth" },
  { label: "Internal Tooth Resorption", name: "internalToothResorption" },
  {
    label: "External Inflammatory Tooth Resorption",
    name: "externalInflammatoryToothResorption"
  },
  {
    label: "External Replacement Root Resorption",
    name: "externalReplacementRootResorption"
  },
  {
    label: "External Surface Root Resorption",
    name: "externalSurfaceRootResorption"
  },
  {
    label: "External Cervical Tooth Resorption",
    name: "externalCervicalToothResorption"
  }
];

export const TOOTH_RESORPTION_OPTIONS = [
  { label: "Type 1", name: "toothResorptionType1" },
  { label: "Type 2", name: "toothResorptionType2" },
  { label: "Type 3", name: "toothResorptionType3" }
];

export const DENTAL_RADIOLOGY_OPTIONS = [
  { label: "Periapical Lucency", name: "periapicalLucency" },
  { label: "Periapical Rarefaction", name: "periapicalRarefaction" },
  { label: "Widened Pulp Canal", name: "widenedPulpCanal" }
];
